exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-3c2ed12a]{--vs-border-color:#e9e9e9;--vs-actions-padding:20px 20px 18px 0px;--vs-controls-size:0.9;--vs-search-input-color:#eee;--vs-dropdown-option--active-color:#eee;--vs-border-radius:9px;--vs-selected-border-width:10px}", ""]);

// exports
